import { styled } from '@linaria/react'
import React, { type FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { colors } from '../styles/colors'
import SvgCheck from '../svgr/Check'
import { Typography } from './Typography'

export const VotedStatus: FC<{
  showIcon?: boolean
  className?: string
}> = ({ showIcon = true, className }) => {
  return (
    <Container className={className}>
      {showIcon && <SvgCheck />}

      <Typography fontSize={10} fontWeight={400} color={colors.white}>
        <FormattedMessage
          id="votedStatus.label"
          defaultMessage="Вы проголосовали"
        />
      </Typography>
    </Container>
  )
}

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${colors.white};
`
